module.exports = __webpack_public_path__ + "img/carousel04.de81357b.webp";